import TagManager from "react-gtm-module";

function AddAwardAffordabilityBox({ ipeds }) {
  const tagManagerArgs = {
    dataLayer: {
      event: "interactionEvent",
      eventName: "award_affordability_box",
      ipeds: ipeds,
    },
  };

  TagManager.dataLayer(tagManagerArgs);
}

export default AddAwardAffordabilityBox;
